module.exports = __webpack_public_path__ + "static/img/table1.fc5cbbed.png";